import { Datalayer } from "@omnia/shared/layers/datalayer";
import { IDatalayerContext, IDataLayerZone, ISeedRateLayer } from "../exports";
import { SeedRateUnit } from "../generated/enums";
import { getSeedRateUnitInfo } from "../units";
import { SeedsDatalayerZone } from "./seedsDatalayerZone";
import { convertSeedRatesFromKg, convertSeedRatesToKg } from "@omnia/shared/crops";


export class SeedsDatalayer extends Datalayer<ISeedRateLayer, SeedPlanInfo> {


    static create(datalayer: ISeedRateLayer, context: IDatalayerContext) {

        const plan = getPlanInfo(datalayer)

        return new SeedsDatalayer(datalayer, context, plan)

    }

    private constructor(
        layer: ISeedRateLayer,
        context: IDatalayerContext,
        readonly plan: SeedPlanInfo,
        readonly planId = plan.planId,
        readonly planName = plan.planName,
        readonly planMinRate = plan.planMinRate,
        readonly planMaxRate = plan.planMaxRate,
        readonly planUnit = plan.planUnit,
        readonly planHasFlatRate = plan.planHasFlatRate,
        readonly useKgHa = plan.planUnit.unit === SeedRateUnit.Kg
    ) {

        super(layer, context, undefined, plan)

    }

    protected createZoneInstance(zone: IDataLayerZone) {
        return new SeedsDatalayerZone(this, zone, this.layerData)
    }

    /**
     * This now always returns false, because even flat rate layers can be edited
     * This property should be removed at some point
     */
    get useFlatRate() {
        return false
    }

    get seeds() {
        return this.datalayer.Seeds
    }

    get valueEditTemplate() {
        return this.useKgHa
            ? "app/seeds/map/zoneRateEditorKg.html"
            : "app/seeds/map/zoneRateEditor.html"
    }

    getTooltipTemplate(feature: any, data: any, editMode: boolean): string {
        return "app/seeds/map/seedsDatalayerZoneTooltip.html";
    }

    supportsSeedRatesConversion(): boolean {
        const { seeds } = this
        return seeds?.TGW > 0
    }

    convertSeedRatesToKg(rate: number): number {

        if (this.supportsSeedRatesConversion()) {
            return convertSeedRatesToKg(rate, this.seeds.TGW, this.planHasFlatRate)
        }
    }

    convertSeedRatesFromKg(rate: number): number {

        if (this.supportsSeedRatesConversion()) {
            return convertSeedRatesFromKg(rate, this.seeds.TGW)
        }

    }

}

export type SeedPlanInfo = ReturnType<typeof getPlanInfo>

export function getPlanInfo(layer: ISeedRateLayer) {


    const {
        PlanId: planId,
        PlanName: planName,
        PlanMinRate: planMinRate,
        PlanMaxRate: planMaxRate,
        PlanUnit: planUnit,
        UseFlatRate: planHasFlatRate
    } = layer

    return {
        planId,
        planName,
        planMinRate,
        planMaxRate,
        planUnit: getSeedRateUnitInfo(planUnit),
        planHasFlatRate
    }

}
